import React, { useCallback, useEffect } from 'react';

import './style.scss';

/* global Amplitude */
const MusicPlayer = () => {

  useEffect(() => {
    const songIndexes = [...Array(16).keys()];

    const songs = songIndexes.map((idx) => {
      idx += 1;

      return {
        name: `Track ${idx}`,
        url: `/island/music/${idx}.mp3`,
      };
    });

    const playlists = {
        default: {
          songs: songIndexes,
          title: 'default',
        },
    };

    Amplitude.init({
      debug: true,
      songs,
      playlists,
      starting_playlist: 'default',
      starting_playlist_song: '0',
    });

    Amplitude.setRepeatPlaylist('default', true);
  }, []);

  return (
    <div className="play-pause">
      <div className="amplitude-play-pause" data-amplitude-playlist="default" id="play-pause"> </div>
    </div>
  );

  return null;
};

export default MusicPlayer;
